/**
 * @generated SignedSource<<884a7ae2b49172347503d44965db442e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MovementsModal_salesAssociate$data = {
  readonly name: string | null;
  readonly avatar: {
    readonly url: string;
  } | null;
  readonly " $fragmentType": "MovementsModal_salesAssociate";
};
export type MovementsModal_salesAssociate$key = {
  readonly " $data"?: MovementsModal_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"MovementsModal_salesAssociate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MovementsModal_salesAssociate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociate",
  "abstractKey": null
};

(node as any).hash = "1638388aa22fb3868f74bd2c75a7337b";

export default node;
